import React from 'react';
import RestaurantEmployees from './RestaurantEmployees';

const NewRestaurantEmployees = () => {
  return <RestaurantEmployees />;
};

export default NewRestaurantEmployees;




